import React, { memo, useMemo } from 'react';
import { Button, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import EmptyScreen from "../../../../../components/EmptyScreen";
import styles from "./styles";
import { errorSvg, emptyGeneralSvg } from "../../../../../lib/svgs";
const useStyles = createUseStyles(styles, 'WidgetEmpty');
const Empty = /*#__PURE__*/memo(_ref => {
  let {
    children,
    type,
    title,
    onRefresh
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const finalTitle = useMemo(() => {
    if (title) return title;
    if (type === 'error') return t('error_we_had_problem');
    return t('label_forcebi_no_results_with_specs');
  }, [type, title, t]);
  const illustration = useMemo(() => {
    if (type === 'error') return errorSvg;
    return emptyGeneralSvg;
  }, [type]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(EmptyScreen, {
    title: finalTitle,
    illustration: illustration,
    overrides: {
      root: {
        style: {
          height: '100%',
          marginTop: '0px'
        }
      },
      emptyView: {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }
      },
      illustration: {
        style: {
          width: type !== 'error' ? '150px' : '125px',
          display: 'flex',
          alignSelf: 'center'
        }
      }
    }
  }, children, onRefresh && /*#__PURE__*/React.createElement(Button, {
    className: classes.refresh,
    type: "secondary",
    onClick: onRefresh,
    onMouseDown: e => e === null || e === void 0 ? void 0 : e.stopPropagation()
  }, t('action_refresh'))));
});
export default Empty;